/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 *  Possible values: Solo = 0, Pro = 1, Scale = 2
 */
export enum Routemize_Constants_SubscriptionTier {
    SOLO = 'Solo',
    PRO = 'Pro',
    SCALE = 'Scale',
}
